import React from "react";
//#region types
import { IconDefinitionConstants } from "utils/constants";
import { TranslationKeys } from "translations";
import { StyleEnums } from "models/enums";
import { StaticInfoMessageProps } from "models/propTypes/messagePropTypes";
//#endregion
//#region components
import Icon from "../icon";
import { Button, Grid } from "@mui/material";
//#endregion
import { CSSHelper, LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const StaticInfoMessage: React.FC<StaticInfoMessageProps> = (props) => {
  const { displayType, header, className, fullWidth, surface, gutterBottom, onClose } = props;

  const getIcon = () => {
    if (props.icon) {
      return props.icon;
    }

    switch (displayType) {
      case StyleEnums.DisplayType.Danger:
        return IconDefinitionConstants.WWarningCanvas;
      case StyleEnums.DisplayType.Warning:
        return IconDefinitionConstants.WWarningCanvas;
      case StyleEnums.DisplayType.Success:
        return IconDefinitionConstants.WCheckCanvas;
      default:
        return IconDefinitionConstants.WInfoCircleFill;
    }
  };

  return (
    <Grid container className={cssExports.snackbarContainer}>
      <Grid
        container
        className={clsx(
          cssExports.snackbar,
          cssExports.fixedSnackBar,
          fullWidth && cssExports.fixedSnackBarFullWidth,
          gutterBottom && cssExports.fixedSnackBarGutterBottom,
          surface === "background" && cssExports.fixedSnackBarSurfaceBackground,
          onClose && cssExports.fixedSnackBarDismissible
        )}
      >
        <Grid
          container
          direction="row"
          className={clsx(CSSHelper.getClassByDisplayType(displayType ?? StyleEnums.DisplayType.Info), className)}
        >
          {!props.hideIcon && (
            <Grid item>
              <Icon className={cssExports.snackBarIcon} icon={getIcon()} />
            </Grid>
          )}
          {props.children && (
            <Grid container direction="column" className={!props.hideIcon ? cssExports.snackbarContent : undefined}>
              {header ? (
                <Grid item xs className={cssExports.header}>
                  {header}
                </Grid>
              ) : (
                <></>
              )}
              <Grid item xs>
                {props.children}
              </Grid>
            </Grid>
          )}
          {onClose && (
            <Button
              onClick={onClose}
              className={cssExports.messageCloseButton}
              aria-label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Close)}
            >
              <Icon icon={IconDefinitionConstants.WTimesThin} />
            </Button>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default StaticInfoMessage;
